
let $revealPlay,
    $scrollCLick,
    $festivalMenuToggle;

$(document).ready(function($) {
    let reveal = new DR_Reveal();
    reveal.init();

    $scrollCLick = $(".js-scroll-to");
    $festivalMenuToggle = $(".js-festival-menu-toggle");

    $('body').on('click', '.js-reveal-play-video', function() {
        let $target = $(this).next();
        let firstLoad = ! $target.data('iframeLoaded');
        if(firstLoad) {
            let iframeHtml = $target.data('iframeHtml');
            let $iframe = $(iframeHtml);
            $iframe.appendTo($target);
            $target.data('iframeLoaded', true);
            $target.parent().addClass('is-active');

            // TODO: Werk niet
            $iframe[0].src += "&autoplay=1";
        }
    });

    $scrollCLick.on('click',  function(e) {
        e.preventDefault();
        var target = $(this).attr('href');
        $(target)[0].scrollIntoView({behavior: "smooth"});
    });

    $festivalMenuToggle.on('click', function(e){
        e.preventDefault();

        $(this).toggleClass('is-open');
        $(this).next().toggleClass('is-open');
    })
});

function DR_Reveal () {

    let $revealContainer;
    let $revealHTML;
    let $revealClose;
    let $revealOpen;

    this.init = function () {
        $revealContainer = $('.js-reveal');
        $revealHTML = $('.js-reveal-html');
        $revealClose = $('.js-reveal-close');
        $revealOpen = $('.js-reveal-open');

        let reveal = this;

        $revealOpen.on('click', function(e){
            e.preventDefault();

            reveal.setHTML($(this));
            reveal.open();
        });

        $revealClose.on('click', function(e){
            e.preventDefault();
            reveal.close();
        });
    }

    this.open = function () {
        $revealContainer.addClass('is-open');

        $body.addClass('overflow-hidden');
    }

    this.close = function () {
        $revealContainer.removeClass('is-open');

        $body.removeClass('overflow-hidden');
    }

    this.setHTML = function($element) {
        let html = $element.find('.js-reveal-open-content').html();
        $revealHTML.html(html);
    }
}
